import { postBiz, rows } from '../core/coreapi';
import { IActivityMonitoring} from './activitymonitoring.models';


export const normalizeActivityMonitoring = (r: any): IActivityMonitoring => ({
  id: r.id ?? r.ati,
  pid: r.pid,
  pdc: r.pdc ?? '',
  pdn: r.pdn ?? '',

  cyi: r.cyi,
  cyc: r.cyc ?? '',
  cyn: r.cyn ?? '',

  ati: r.ati,
  atc: r.atc ?? '',
  atn: r.atn ?? '',

  tct: Number(r.tct ?? 0),
  ctc: Number(r.ctc ?? 0),
  itc: Number(r.itc ?? 0),
  ntc: Number(r.ntc ?? 0),
  wvc: Number(r.wvc ?? 0),
  exc: Number(r.exc ?? 0),

  rpr: Number(r.rpr ?? 0),
  apr: Number(r.apr ?? 0),
  fpr: Number(r.fpr ?? 0),
  var: Number(r.var ?? 0),

  pam: Number(r.pam ?? 0),
  cma: Number(r.cma ?? 0),
  iva: Number(r.iva ?? 0),
  pda: Number(r.pda ?? 0),
  aca: Number(r.aca ?? 0),

  evc: Number(r.evc ?? 0),
  apc: Number(r.apc ?? 0),

  lud: r.lud ?? '',
  hlt: r.hlt ?? 'ALIGNED',

  sts: r.sts ?? 1,
  ast: r.ast ?? 1,

  raw: r,
});

export const fetchActivityMonitoring = async (params: any = {}) =>
  rows(await postBiz({
    s: 'activitymonitoring',
    a: 'find',
    pid: params.periodid ?? null,
    cyi: params.cycleid ?? null,
    ati: params.activityid ?? null,
    cci: params.costcenterid ?? null,
    sts: params.status ?? 1,
    src: params.search ?? null,
    pgo: params.pageoffset ?? 0,
    pgl: params.pagelimit ?? 100,
  })).map(normalizeActivityMonitoring);